import React, { Component } from 'react';
import { Collapse, Navbar, NavbarToggler, NavbarBrand, Nav, NavItem, NavLink } from 'reactstrap';
import { PropTypes } from 'prop-types';
import { Link } from "react-router-dom";
import Menu from './Menu';
import '../_Content/css/titulo.css';

class Header extends Component {

	constructor(props) {
		super(props);

		this.toggleNavbar = this.toggleNavbar.bind(this);
		this.state = {
			collapsed: true
		};

		this.menuItens = new Menu();
		this.menuItens = this.menuItens.Itens;
	};

	toggleNavbar() {
		this.setState({
			collapsed: !this.state.collapsed
		});
	};

	render(){

		return(
			<header>
				<Navbar color="faded" light>
					<NavbarBrand className="mr-auto titulo-sistema">
						<img src="/img/logo-econet.svg" alt="Econet Editora"/>
						<span className='titulo-colapse'>EcoAuditor</span>
					</NavbarBrand>
					<NavbarToggler onClick={this.toggleNavbar} className="mr-2" />
					<Collapse isOpen={!this.state.collapsed} navbar>
						<Nav navbar>
							{
								this.menuItens.map((item) => {
									return (
										<NavItem>
                                            {(item.title === 'enviar-arquivos') ? (
                                                <NavLink tag={Link} to={item.path} onClick={this.props.actionModalUpload}>
                                                    <i className={item.ico}></i>
                                                    <span>{item.nome}</span>
                                                </NavLink>
                                            )
                                            :
                                            (
                                                <NavLink tag={Link} to={item.path}>
                                                    <i className={item.ico}></i>
                                                    <span>{item.nome}</span>
                                                </NavLink>
                                            )
                                            }
										</NavItem>
									)
								})
							}
							<NavItem>
								<a href="https://www.econeteditora.com.br/solucoes/index.php?acao=envio&form[destino]=10&form[area]=34&form[tipo]=6&form[assunto]=413" target="_blank" className="nav-link">
									<i className="ecoico ecoico-support"></i>
									<span>Suporte Técnico</span>
								</a>
							</NavItem>
							<NavItem>
								<a href="javascript:void(0);" className="nav-link">
									<i className="ecoico ecoico-feedback"></i>
									<span>Deixe-nos sua opinião</span>
								</a>
							</NavItem>

						</Nav>
					</Collapse>
				</Navbar>
			</header>
		)
	}
}

export default Header;


// WEBPACK FOOTER //
// ./src/Layout/Header.jsx